import { gql } from '@apollo/client'

export default gql(`
    query getDRMSettings{
        getDRMLicenseSettings{
            apiKey
            licenseUrl
        }
    }`
)
